<template>
    <!-- 쿠키 안내 (오른쪽 아래, 메모·도움말 버튼 왼쪽)
         - 쿠키가 막힌 브라우저: 경고 + 허용 방법 (닫으면 이번 접속 동안 숨김, 다음 접속에 다시)
         - 처음 접속: 쿠키 사용 안내 [허용] = 다시 안 물어봄 / [허용 안 함] = 다음 접속에 다시 -->
    <div v-if="mode" class="cookie-notice" :class="mode" role="dialog" aria-live="polite" :aria-label="mode == 'blocked' ? '쿠키 차단 안내' : '쿠키 사용 안내'">
        <template v-if="mode == 'blocked'">
            <div class="cn-head"><i class="bi bi-exclamation-triangle-fill"></i> 쿠키가 차단되어 있어요</div>
            <p class="cn-text">이 브라우저에서 쿠키를 저장할 수 없어 <b>알림 읽음 표시, 아이디 저장, 검색 조건</b>이 저장되지 않아요. 브라우저 설정에서 pasm.kr 쿠키를 허용해 주세요.</p>
            <ol v-if="show_guide" class="cn-guide">
                <template v-if="browser == 'Edge'">
                    <li>주소창에 <code>edge://settings/content/cookies</code> 입력</li>
                    <li>'사이트에서 쿠키 데이터를 저장하고 읽도록 허용' 켜기</li>
                    <li>'차단' 목록에 pasm.kr 이 있으면 삭제, '허용'에 <code>[*.]pasm.kr</code> 추가</li>
                </template>
                <template v-else-if="browser == 'Chrome' || browser == 'Whale'">
                    <li>주소창 왼쪽 자물쇠(사이트 정보) 클릭 → 사이트 설정</li>
                    <li>'쿠키 및 사이트 데이터'를 허용으로 변경</li>
                </template>
                <template v-else>
                    <li>브라우저 설정 → 개인정보(쿠키) 메뉴에서 pasm.kr 쿠키를 허용</li>
                </template>
                <li>설정 후 이 페이지를 새로고침</li>
            </ol>
            <div class="cn-btns">
                <button type="button" class="btn btn-sm cn-btn-ghost" @click="show_guide = !show_guide">{{ show_guide ? '방법 닫기' : '허용 방법 보기' }}</button>
                <button type="button" class="btn btn-sm cn-btn" @click="closeBlocked()">닫기</button>
            </div>
        </template>
        <template v-else>
            <div class="cn-head"><i class="bi bi-info-circle-fill"></i> 쿠키 사용 안내</div>
            <p class="cn-text">알림 읽음 표시, 아이디 저장, 검색 조건 기억을 위해 쿠키를 사용합니다. 쿠키 사용을 허용해 주세요.</p>
            <div class="cn-btns">
                <button type="button" class="btn btn-sm cn-btn-ghost" @click="declineFirst()">허용 안 함</button>
                <button type="button" class="btn btn-sm cn-btn" @click="acceptFirst()">허용</button>
            </div>
        </template>
    </div>
</template>

<script>
import { cookieWorks, browserInfo } from '@/utils/clientEnv';

const ACK_KEY = 'pasm_cookie_notice_ack';          //처음 안내 확인 (localStorage)
const HIDE_KEY = 'pasm_cookie_blocked_hidden';     //차단 경고를 이번 접속 동안 숨김 (sessionStorage)
const DECLINE_KEY = 'pasm_cookie_notice_declined'; //'허용 안 함' — 이번 접속 동안만 숨기고 다음 접속에 다시 (sessionStorage)

function getStore(store, key) { try { return store.getItem(key); } catch (e) { return null; } }
function setStore(store, key, v) { try { store.setItem(key, v); } catch (e) { /* noop */ } }

export default {
    name: 'CookieNotice',
    data() {
        return { mode: '', show_guide: false, browser: browserInfo().name };
    },
    methods: {
        check() {
            if (!cookieWorks()) {
                this.mode = getStore(sessionStorage, HIDE_KEY) ? '' : 'blocked';
            } else {
                this.mode = (getStore(localStorage, ACK_KEY) || getStore(sessionStorage, DECLINE_KEY)) ? '' : 'first';
            }
        },
        acceptFirst() {
            setStore(localStorage, ACK_KEY, '1');
            this.mode = '';
        },
        //허용 안 함: 이번 접속(브라우저 탭을 닫기 전)까지만 숨김 → 다음 접속에 다시 물어봄
        declineFirst() {
            setStore(sessionStorage, DECLINE_KEY, '1');
            this.mode = '';
        },
        closeBlocked() {
            setStore(sessionStorage, HIDE_KEY, '1');
            this.mode = '';
        },
    },
    mounted() {
        //화면이 다 뜬 뒤 살짝 늦게 (로그인 화면 첫 인상 가리지 않게)
        setTimeout(this.check, 800);
    },
};
</script>

<style scoped>
    .cookie-notice {
        position: fixed; right: calc(5rem + 54px + 16px); bottom: 5rem; z-index: 1040; width: 340px; max-width: calc(100vw - 24px);
        background: #fff; border-radius: 12px; padding: 14px 16px 12px; box-shadow: 0 6px 24px rgba(0, 0, 0, .16); border: 1px solid #eee; text-align: left;
    }
    .cookie-notice.blocked { border-top: 3px solid #E5484D; }
    .cookie-notice.first { border-top: 3px solid #F6951C; }
    .cn-head { font-size: 15px; font-weight: 700; color: #222; display: flex; align-items: center; gap: 6px; }
    .cookie-notice.blocked .cn-head i { color: #E5484D; }
    .cookie-notice.first .cn-head i { color: #F6951C; }
    .cn-text { margin: 8px 0 0 !important; font-size: 13px !important; line-height: 1.6; color: #555; white-space: normal; }
    .cn-guide { margin: 8px 0 0; padding-left: 18px; font-size: 12.5px; line-height: 1.7; color: #444; }
    .cn-guide code { font-size: 12px; background: #F4F4F5; padding: 1px 4px; border-radius: 4px; color: #333; }
    .cn-btns { display: flex; justify-content: flex-end; gap: 6px; margin-top: 12px; }
    .cookie-notice .cn-btns .btn { font-size: 13px !important; line-height: 1.5; }
    .cn-btn { background: #F6951C; color: #fff; font-weight: 700; padding: 4px 14px; }
    .cn-btn:hover { background: #e2850f; color: #fff; }
    .cn-btn-ghost { background: #fff; color: #555; border: 1px solid #ddd; padding: 4px 12px; }
    @media (max-width: 768px) {
        .cookie-notice { right: 12px; left: 12px; bottom: 12px; width: auto; }
    }
</style>
